export default __webpack_public_path__ + "static/media/dummyImage.a08ca98a.svg";